import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useNavigate } from "react-router-dom";
import { updateUserProfile } from "../features/userProfile/userProfileSlice";

// Validation schema
const profileValidationSchema = yup.object().shape({
  bsaNumber: yup
    .string()
    .required("BSA number is required")
    .matches(/^\d+$/, "BSA number must contain only digits")
    .max(10, "BSA number must not exceed 10 digits"),
});

function CompleteProfile() {
  const dispatch = useDispatch();
  const { user, logout } = useKindeAuth();
  const navigate = useNavigate();

  const { isLoading } = useSelector((state) => state.userProfile);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(profileValidationSchema),
    mode: "onBlur",
  });

  const onSubmit = (data) => {
    dispatch(updateUserProfile({ bsa_number: data.bsaNumber.trim() }))
      .unwrap()
      .then(() => {
        setTimeout(() => {
          navigate("/my-record");
        }, 1500);
      });
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <Paper sx={{ padding: 4, width: "100%", maxWidth: 400 }}>
        <Typography variant="h5" mb={2}>
          Complete Your Profile
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          Welcome, {user?.given_name}! Please add your BSA number to continue.
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              {...register("bsaNumber")}
              label="BSA Number"
              placeholder="e.g., 123456"
              fullWidth
              disabled={isLoading}
              error={!!errors.bsaNumber}
              helperText={errors.bsaNumber?.message}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isLoading}
              sx={{ mt: 1 }}
            >
              {isLoading ? "Saving..." : "Continue"}
            </Button>

            <Button variant="outlined" color="error" onClick={() => logout()}>
              Logout
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}

export default CompleteProfile;
